class HeaderLinks extends HTMLElement {
  constructor() {
    super();
    this.linksWithSubmenu = this.querySelectorAll(".has-submenu");
    this.clickHandler = this.handleClick.bind(this);
    this.documentClickHandler = this.handleDocumentClick.bind(this);
  }
  connectedCallback() {
    this.linksWithSubmenu.forEach((el) => {
      el.querySelector("span").addEventListener("click", this.clickHandler);
    });

    this.linksWithSubmenu.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const distanceFromRight = viewportWidth - rect.right;

      if (distanceFromRight < 400) {
        el.classList.add("left-dropdown-menu");
      }
    });

    document.addEventListener("click", this.documentClickHandler);
  }

  handleClick(event) {
    event.stopPropagation();
    const menuItem = event.target.closest(".has-submenu");

    this.closeOtherMenus(menuItem);
    if (menuItem.dataset.url && menuItem.classList.contains("active")) {
      window.location.href = menuItem.dataset.url;
      return;
    }
    menuItem.classList.toggle("active");
    menuItem.querySelector("div").classList.toggle("active");
    if (
      menuItem.classList.contains("main-level") &&
      menuItem.querySelector("span").scrollWidth ==
        menuItem.querySelector(".header-links--links").scrollWidth
    ) {
      menuItem.querySelector(".header-links--links").style.borderRadius =
        "0 0 12px 12px";
    }
  }

  closeOtherMenus(currentItem) {
    let parentContainer;
    if (currentItem.closest(".header-links--last-level")) {
      parentContainer = currentItem
        .closest(".header-links--last-level")
        .closest(".has-submenu");
    } else if (currentItem.closest(".header-links--childs-links")) {
      parentContainer = currentItem
        .closest(".header-links--childs-links")
        .closest(".has-submenu");
    } else if (currentItem.closest(".header-links--links")) {
      parentContainer = currentItem
        .closest(".header-links--links")
        .closest(".has-submenu");
    } else {
      parentContainer = this;
    }

    let siblings;
    if (parentContainer === this) {
      siblings = Array.from(this.children).filter((child) =>
        child.classList.contains("has-submenu")
      );
    } else {
      const parentDropdown = parentContainer.classList.contains(
        "header-link--child-sub"
      )
        ? parentContainer.querySelector(".header-links--last-level")
        : parentContainer.classList.contains("header-link--child")
        ? parentContainer.querySelector(".header-links--childs-links")
        : parentContainer.querySelector(".header-links--links");

      siblings = Array.from(parentDropdown?.children || []).filter(
        (child) =>
          child.classList.contains("has-submenu") ||
          child.classList.contains("header-link--child") ||
          child.classList.contains("header-link--child-sub") ||
          child.classList.contains("header-links--last-item")
      );
    }

    siblings.forEach((sibling) => {
      if (sibling !== currentItem && sibling.classList.contains("active")) {
        sibling.classList.remove("active");
        const dropdowns = sibling.querySelectorAll("div.active");
        dropdowns.forEach((dropdown) => {
          dropdown.classList.remove("active");
        });
        const activeSubmenuItems = sibling.querySelectorAll(
          ".has-submenu.active"
        );
        activeSubmenuItems.forEach((submenuItem) => {
          submenuItem.classList.remove("active");
        });
      }
    });
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeAllMenus();
    }
  }

  closeAllMenus() {
    const openMenus = this.querySelectorAll(".has-submenu.active");
    openMenus.forEach((menu) => {
      menu.classList.remove("active");
      const activeDropdowns = menu.querySelectorAll("div.active");
      activeDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("active");
      });
    });
  }
}
customElements.define("header-links", HeaderLinks);
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.activeMenuLevel = null;
    this.menuLevels = {};
    this.mainMenuLevel = null;
  }

  connectedCallback() {
    this.openBtn = this.querySelector(".header--mobile-menu--open");
    this.closeBtn = this.querySelector(".header--mobile-menu--close");
    this.menuContainer = this.querySelector(".mobile-menu-container");
    this.mainMenuLevel = this.querySelector(".menu-level-main");
    this.backButtons = this.querySelectorAll(".back-button");
    this.nextLevelButtons = this.querySelectorAll(".next-level-button");
    this.closeMenuButtons = this.querySelectorAll(".menu-close");
    this.breadcrumbs = document.querySelector(".breadcrumbs");

    const menuLevels = this.querySelectorAll(".menu-level");
    menuLevels.forEach((level) => {
      if (level.id) {
        this.menuLevels[level.id] = level;
      }
    });

    this.closeBtn.style.display = "none";
    this.menuContainer.style.display = "none";
    this.menuContainer.style.transform = "none";

    const header = document.querySelector("header");
    const headerHeight = header ? header.scrollHeight : 0;
    const breadcrumbsHeight = this.breadcrumbs
      ? this.breadcrumbs.scrollHeight
      : 0;
    this.menuContainer.style.top = `${Math.max(
      headerHeight - breadcrumbsHeight,
      0
    )}px`;

    this.activeMenuLevel = this.mainMenuLevel;

    this.openBtn.addEventListener("click", () => this.openMenu());
    this.closeBtn.addEventListener("click", () => this.closeMenu());

    this.backButtons.forEach((button) => {
      button.addEventListener("click", () => this.goBack());
    });

    this.nextLevelButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const submenuId = button.getAttribute("data-submenu");
        if (submenuId && this.menuLevels[submenuId]) {
          this.showSubmenu(submenuId);
        }
      });
    });

    this.closeMenuButtons.forEach((button) => {
      button.addEventListener("click", () => this.closeMenu());
    });

    document.addEventListener("click", (e) => {
      if (this.isOpen && !this.contains(e.target)) {
        this.closeMenu();
      }
    });
  }

  openMenu() {
    this.isOpen = true;
    this.openBtn.style.display = "none";
    this.closeBtn.style.display = "flex";
    this.menuContainer.style.display = "block";
    document.querySelector(".cstm-header").style.backgroundColor = "white";

    this.resetToMainMenu();
    document.body.style.overflow = "hidden";
  }

  closeMenu() {
    this.isOpen = false;
    this.openBtn.style.display = "flex";
    this.closeBtn.style.display = "none";
    this.menuContainer.style.display = "none";
    document.querySelector(".cstm-header").style.backgroundColor =
      "transparent";

    document.body.style.overflow = "";
    setTimeout(() => this.resetToMainMenu(), 300);
  }

  resetToMainMenu() {
    Object.values(this.menuLevels).forEach((level) =>
      level.classList.remove("active")
    );
    if (this.mainMenuLevel) {
      this.mainMenuLevel.classList.add("active");
      this.activeMenuLevel = this.mainMenuLevel;
    }
  }

  showSubmenu(submenuId) {
    if (this.activeMenuLevel) {
      this.activeMenuLevel.classList.remove("active");
    }

    const submenu = this.menuLevels[submenuId];
    if (submenu) {
      submenu.classList.add("active");
      this.activeMenuLevel = submenu;
    }
  }

  goBack() {
    if (this.activeMenuLevel?.id) {
      const currentId = this.activeMenuLevel.id;
      const parts = currentId.split("-");

      if (parts.length > 2) {
        const parentId = parts.slice(0, parts.length - 1).join("-");
        if (this.menuLevels[parentId]) {
          this.showSubmenu(parentId);
        } else {
          this.resetToMainMenu();
        }
      } else {
        this.resetToMainMenu();
      }
    }
  }
}

customElements.define("mobile-menu", MobileMenu);
